import React from 'react';
import { TicketList } from '../components/TicketList';
import { ChatView } from '../components/ChatView';
import { useStore } from '../store/useStore';

export const InboxScreen = () => {
  const { activeTicketId } = useStore();

  return (
    <div className="flex w-full h-full mobile-content-safe">
      {/* List panel */}
      <div className={`w-full md:w-[400px] h-full flex-shrink-0 ${activeTicketId ? 'hidden md:flex' : 'flex'}`}>
        <TicketList />
      </div>

      {/* Chat panel */}
      <div className={`flex-1 h-full min-w-0 ${!activeTicketId ? 'hidden md:flex' : 'flex'}`}>
        <ChatView />
      </div>
    </div>
  );
};
